import { render } from "./WebhookTrigger.vue?vue&type=template&id=0a82b20e"
import script from "./WebhookTrigger.vue?vue&type=script&lang=js"
export * from "./WebhookTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__